import { I18n } from '@app/i18n/strings-keys';

export enum HAWKER_SESSION_STATUS_VALUE {
  New = 'new',
  Open = 'open',
  Canceled = 'canceled',
  Closed = 'closed',
  CloseOut = 'closeOut',
}

export const HAWKER_SESSION_STATUS_LABEL_TEXT_MAPPING = {
  [HAWKER_SESSION_STATUS_VALUE.New]: I18n.Status.New,
  [HAWKER_SESSION_STATUS_VALUE.Open]: I18n.Status.Open,
  [HAWKER_SESSION_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
  [HAWKER_SESSION_STATUS_VALUE.Closed]: I18n.Status.Closed,
};

export const HAWKER_SESSION_STATUS_OPTIONS: { text: string; value: string }[] =
  [
    { text: I18n.Status.New, value: HAWKER_SESSION_STATUS_VALUE.New },
    { text: I18n.Status.Open, value: HAWKER_SESSION_STATUS_VALUE.Open },
    { text: I18n.Status.Canceled, value: HAWKER_SESSION_STATUS_VALUE.Canceled },
    { text: I18n.Status.Closed, value: HAWKER_SESSION_STATUS_VALUE.Closed },
  ];
